<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Rewards List <span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn" (click)="exportExcel()"> <span><img src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>Export</button>
				<button class="addBTn" (click)="addNewReward()"> <span><img src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Add Reward</button>
			</div>
		</div>
	<p-toast key="toastMsg"></p-toast>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [(ngModel)]="startDate"
							placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [(ngModel)]="endDate" placeholder="To: dd / mm / yy"
							[showIcon]="true"></p-calendar>
					</li>
					<li>
					<button class="searchFilterBtn" (click)="loadRewards(lastTableLazyLoadEvent)">
						<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
					</button>
					</li>
					<li>
						<button (click)="clear()" class="clearFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>
					</li>
				</ul>
			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table #dt [value]="rewardlist" [paginator]="true" [rows]="10" [lazy]="true"
						(onLazyLoad)="loadRewards($event)" [totalRecords]="totalRecords"
						[rowsPerPageOptions]="[5,10,15,20]"
						styleClass="p-datatable-gridlines p-datatable-striped p-datatable">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pSortableColumn="reward_name" class="reward_nameTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Reward Name
										<p-sortIcon field="reward_name"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="description">
									<div class="p-d-flex p-jc-between p-ai-center">
										Description
                                        <p-sortIcon field="description"></p-sortIcon>
									</div>
								</th>
                                <th class="viewBtnTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Reward Image
									</div>
								</th>
								<th pSortableColumn="description" class="sizeTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Size Available
                                        <p-sortIcon field="size_available"></p-sortIcon>
									</div>
								</th>
                                 <th pSortableColumn="coins_required">
									<div class="p-d-flex p-jc-between p-ai-center">
										Coins Required
                                        <p-sortIcon field="coins_required"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="status" class="statusTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_at" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Date of Creation
										<p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_by" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Created By
										<p-sortIcon field="created_by"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_at" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Modified On
										<p-sortIcon field="updated_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_by" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Modified By
										<p-sortIcon field="updated_by"></p-sortIcon>
									</div>
								</th>
								<th class="actionTD  p-frozen-column">
									Action
								</th>
							</tr>
							<tr>
								<th [ngSwitch]="reward_name" class="reward_nameTd">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'reward_name', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['reward_name'] ? dt.filters['reward_name'].value : ''" [(ngModel)]="reward_name" />
								</th>
                                <th [ngSwitch]="description">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'description', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['description'] ? dt.filters['description'].value : ''" [(ngModel)]="description" />
								</th>
								<th class="viewBtnTd">
								</th>
								<th [ngSwitch]="size" class="sizeTd">
									<p-dropdown #pDropDownId [options]="sizes"
										(onChange)="dt.filter($event.value, 'size', 'equals')"
										styleClass="p-column-filter" placeholder="Select Size" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="coins_required">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'coins_required', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['coins_required'] ? dt.filters['coins_required'].value : ''" [(ngModel)]="coins_required" />
								</th>
                                <th [ngSwitch]="status" class="statusTD">
									<p-dropdown #pDropDownId2 [options]="statuses"
										(onChange)="dt.filter($event.value, 'status', 'equals')"
										styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="created_at" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-calendar #pCalendarId class="p-column-filter" inputId="calendar" appendTo="body"
										dateFormat="dd/mm/yy" (onSelect)="dt.filter($event,'created_at', 'dateIs')"
										[showIcon]="true" monthNavigator="true" yearNavigator="true"
										yearRange="2022:2050" [(ngModel)]="calvalue"></p-calendar>
								</th>
								<th [ngSwitch]="createdby" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'createdby', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['createdby'] ? dt.filters['createdby'].value : ''" [(ngModel)]="createdby" />
								</th>
								<th [ngSwitch]="updated_at" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-calendar #pCalendarId class="p-column-filter" inputId="calendar" appendTo="body"
										dateFormat="dd/mm/yy" (onSelect)="dt.filter($event,'updated_at', 'dateIs')"
										[showIcon]="true" monthNavigator="true" yearNavigator="true"
										yearRange="2022:2050" [(ngModel)]="ucalvalue"></p-calendar>
								</th>
								<th [ngSwitch]="updatedby" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'updatedby', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['updatedby'] ? dt.filters['updatedby'].value : ''" [(ngModel)]="updatedby" />
								</th>
								<th class="actionTD  p-frozen-column">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-reward>
							<tr class="p-selectable-row">
								<td class="reward_nameTd">
									{{reward.reward_name}}
								</td>
								<td class="col-180 titleTD">
									<span class="textOverFlow1" [pTooltip]="reward.description" severity="secondary" tooltipPosition="bottom">
										{{reward.description}}
									</span>
									<ng-template #[reward.description]>
										<div class="flex align-items-center">
											<span> {{reward.description}}</span>
										</div>
									</ng-template>
								</td>
								<td class="viewBtnTd">
									<p-galleria [effect]="slide" [(value)]="reward.reward_images"
										[(visible)]="reward.rewardVisible" [responsiveOptions]="responsiveOptions"
										[containerStyle]="{'max-width': '850px'}" [numVisible]="7" [circular]="true"
										[fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false"
										[baseZIndex]="100000">
										<ng-template pTemplate="item" let-item>
											<img [src]="item.reward_image_src"
												style="width:100%; height:100%; display: block;" />
										</ng-template>
									</p-galleria>
									<button pButton *ngIf="reward.reward_images.length > 0" type="button" icon="pi pi-eye" label="View" (click)="reward.rewardVisible=true"></button>
								</td>
								<td class="statusTD">
									<div class="swichTable">
										<p-inputSwitch [(ngModel)]="reward.size" (onChange)="changeSize(reward)">
										</p-inputSwitch>
										<div class="label activeText" *ngIf="reward.size">
											Yes
										</div>
										<div class="label InActiveText" *ngIf="!reward.size">
											No
										</div>
									</div>
								</td>
								<td>
									{{reward.coins}}
								</td>
								<td class="statusTD">
									<div class="swichTable">
										<p-inputSwitch [(ngModel)]="reward.status" (onChange)="changeStatus(reward)">
										</p-inputSwitch>
										<div class="label activeText" *ngIf="reward.status">
											Active
										</div>
										<div class="label InActiveText" *ngIf="!reward.status">
											Inactive
										</div>
									</div> 
								</td>
								<td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{reward.created_at | date: 'dd/MM/yyyy'}}
								</td>
								<td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{reward.createdBy}}
								</td>
								<td [ngClass]="hide ? 'hide-column' : 'show-column'">
									<span *ngIf="reward.updated_at != undefined && reward.updated_at  !='Invalid Date'">{{reward.updated_at | date: 'dd/MM/yyyy'}}</span>
								</td>
								<td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{reward.updatedBy}}
								</td>
								<td class="actionTD  p-frozen-column">
									<ul class="actionList">
										<li>
											<button (click)="editReward(reward.id)" class="editBtn"><img src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
										</li>
										<li *ngIf="this.rewardPermissions['edit']">
											<button (click)="deleteReward(reward)" class="deleteBtn"><img src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
										</li>
                                        <li>
											<button (click)="requestList(reward.id)" class="editBtn" pTooltip="Requests List" tooltipPosition="top"><img src="../../../assets/images/backend-image/common-images/notification.svg" style="width: 19px;"></button>
										</li>
									</ul>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="10">No Rewards found.</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</div>
	</div>
</div>
<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>